import { Phone } from "lucide-react";
import { BUSINESS } from "../lib/data";

export default function StickyMobileBar() {
  return (
    <div
      data-testid="sticky-mobile-bar"
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-slate-200 px-3 py-3 shadow-[0_-6px_20px_-12px_rgba(0,0,0,0.2)]"
    >
      <div className="flex gap-2">
        <a
          href={`tel:${BUSINESS.phoneRaw}`}
          data-testid="sticky-call-button"
          className="btn-primary flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-full font-semibold text-sm"
        >
          <Phone className="w-4 h-4" /> Chiama Ora
        </a>
        <a
          href={`https://wa.me/${BUSINESS.whatsappRaw}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-whatsapp-button"
          className="btn-wa flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-full font-semibold text-sm"
        >
          <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor"><path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 018.413 3.488 11.821 11.821 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zM17.42 14.382c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.149-.173.198-.297.298-.495.099-.198.05-.371-.025-.52-.075-.149-.669-1.611-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z"/></svg>
          WhatsApp
        </a>
      </div>
    </div>
  );
}
